import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "next-intl";
import { ListingType } from "../../../api/schema";
export function useRoomDetails() {
  const $ = _c(6);
  const {
    control
  } = useFormContext();
  const t = useTranslations("modules.listings.addRoomListing.roomDetails");
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "listingType"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const listingType = useWatch(t0);
  const isDemand = listingType === ListingType.DEMAND;
  let t1;
  if ($[2] !== control || $[3] !== isDemand || $[4] !== t) {
    t1 = {
      control,
      t,
      isDemand
    };
    $[2] = control;
    $[3] = isDemand;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}